import { MultiSelect as ExoMultiSelect } from "@exopengithub/exokit";
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

// Portal wrapper: injects Swedish default search/no-results/select-all labels.
export const MultiSelect = (props: ComponentProps<typeof ExoMultiSelect>) => {
	const { t } = useTranslation();
	return (
		<ExoMultiSelect
			searchPlaceholder={t("Search")}
			noResultsLabel={t("No results")}
			selectAllLabel={t("Select all")}
			deselectAllLabel={t("Deselect all")}
			dismissErrorAriaLabel={t("Dismiss error")}
			{...props}
		/>
	);
};
